<template>
  <v-card tile :elevation="elevation" :loading="cardLoading" :max-width="maxWidth">
    <v-card-title
      v-if="!hideTitle"
      class="subtitle-1 font-weight-bold"
      :class="{
        red: type === 'delete',
        [theme]: theme && true,
        'white--text': theme || type === 'delete',
      }"
    >
      {{ title }}
      <v-spacer></v-spacer>
      <v-btn icon :dark="!!theme || type === 'delete'" @click="$emit('cancel')" v-if="topCancelBtn">
        <v-icon v-text="icons.mdiClose"></v-icon>
      </v-btn>
    </v-card-title>

    <v-divider v-if="!hideTitle"></v-divider>

    <v-form @submit.prevent="$emit('submit')">
      <v-card-text class="pt-4">
        <slot></slot>
      </v-card-text>

      <v-alert v-if="errorMessage" type="error">{{ errorMessage }}</v-alert>

      <div :class="{ stickyFooter }">
        <v-divider v-if="!hideDefaultFooter"></v-divider>

        <v-card-actions v-if="!hideDefaultFooter" :class="{ stickyFooter }">
          <v-spacer></v-spacer>
          <v-btn
            v-if="cancelBtn"
            text
            class="text-capitalize"
            style="font-size: 0.9rem"
            @click="$emit('cancel')"
            >{{ cancelText[lang] }}</v-btn
          >
          <v-btn
            v-if="submitBtn2"
            :color="btn2Color || (type === 'delete' ? 'red' : theme || 'secondary')"
            class="text-capitalize px-5"
            style="font-size: 0.9rem"
            :dark="!!theme || type === 'delete'"
            depressed
            :loading="loading"
            :disabled="disabled"
            @click="$emit('submit2')"
            >{{ submitText2[lang] }}
            <span v-if="timer" class="px-1">({{ timer }})</span>
          </v-btn>
          <v-btn
            v-if="submitBtn"
            type="submit"
            :color="type === 'delete' ? 'red' : theme || 'secondary'"
            class="text-capitalize px-5"
            style="font-size: 0.9rem"
            :dark="!!theme || type === 'delete'"
            depressed
            :loading="loading"
            :disabled="disabled"
            >{{ submitText[lang] }}
            <span v-if="timer" class="px-1">({{ timer }})</span>
          </v-btn>
        </v-card-actions>
      </div>
    </v-form>
  </v-card>
</template>

<script>
import { mdiClose } from '@mdi/js';

export default {
  name: 'BCard',
  props: {
    type: {
      type: String,
      default: 'default',
    },
    title: String,
    topCancelBtn: {
      type: Boolean,
      default: true,
    },
    theme: {
      type: String,
      default: '',
    },
    cancelBtn: {
      type: Boolean,
      default: true,
    },
    cancelText: {
      type: Object,
      default: () => ({ el: 'Κλείσιμο', en: 'cancel', it: 'cancel' }),
    },
    submitBtn: {
      type: Boolean,
      default: true,
    },
    submitBtn2: {
      type: Boolean,
      default: false,
    },
    btn2Color: {
      type: String,
      default: null,
    },
    submitText: {
      type: Object,
      default: () => ({ el: 'Υποβολή', en: 'submit', it: 'submit' }),
    },
    submitText2: {
      type: Object,
      default: () => ({
        el: 'Αποθηκευση',
        en: 'Save',
        it: 'Risparmiare',
      }),
    },
    hideDefaultFooter: {
      type: Boolean,
      default: false,
    },
    loading: Boolean,
    cardLoading: Boolean,
    errorMessage: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    timer: {
      type: String,
      default: '',
    },
    stickyFooter: {
      type: Boolean,
      default: false,
    },
    hideTitle: {
      type: Boolean,
      default: false,
    },
    elevation: {
      type: String,
      default: undefined,
    },
    maxWidth: {
      type: [String, undefined],
      default: undefined,
    },
  },

  data: () => ({
    icons: { mdiClose },
  }),

  computed: {
    lang() {
      return this.$route.params.lang;
    },
  },

  mounted() {
    this.$clearFocus();
  },
};
</script>
<style>
.stickyFooter {
  position: sticky;
  bottom: 0;
  left: 0;
  background: white;
  z-index: 10;
}
</style>
